import { computed, reactive } from '@nuxtjs/composition-api';
import flowWithoutSubscription from './flowWithoutSubscription'
import flowWithDeviceAndSubscription from './flowWithDeviceAndSubscription'
import flowWithMobileVoiceSubscriptionOnly from './flowWithMobileVoiceSubscriptionOnly'
import flowWithMobileBroadBandSubscription from './flowWithMobileBroadBandSubscription'
import noFlow from './noFlow'
import useTlmCart from '@/composable/useTlmCart';
import { CHECKOUT_FLOW } from '~/constants/CheckoutFlow';
import useCartQueries from '~/composable/useCartQueries';

const checkouts = {
  flowWithMobileVoiceSubscriptionOnly,
  flowWithDeviceAndSubscription,
  flowWithMobileBroadBandSubscription,
  flowWithoutSubscription,
  noFlow
}



/**
 * @param {string} name
 */
const internalState = reactive({})
export default function useCheckout (app) {
  const {
    isCartEmpty,
    isLoading,
    isMobileVoiceSubscriptionOnly,
    cart
  } = useTlmCart(app);
  const { isAnyItemAssociatedWithMobileVoiceSubscription, isAnyItemAssociatedWithMobileBroadBand } = useCartQueries(app, cart);

  // eslint-disable-next-line complexity
  const checkoutType = computed(() => {
    if (isCartEmpty.value || isLoading.value) {
      return CHECKOUT_FLOW.NO_FLOW
    } else if (isMobileVoiceSubscriptionOnly.value) {
      return CHECKOUT_FLOW.WITH_MV_SUBSCRIPTION_ONLY
    } else if (isAnyItemAssociatedWithMobileVoiceSubscription.value) {
      return CHECKOUT_FLOW.DEVICE_WITH_SUBSCRIPTION
    } else if (isAnyItemAssociatedWithMobileBroadBand.value) {
      return CHECKOUT_FLOW.WITH_MOBILE_BROADBAND_SUBSCRIPTION
    } else {
      return CHECKOUT_FLOW.WITH_OUT_SUBSCRIPTION
    }
  })

  if (!checkouts[checkoutType.value]) {
    throw new Error(`Checkout type could not be determined, this could lead to malfunction of the flow. The checkout type({checkoutType.value) value is:[ ${checkoutType.value}]`)
  }

  const setCheckoutState = (stateData) => {
    const nextState = stateData || checkouts[checkoutType.value](app)

    // IMPORTANT: keep the original reactive reference stable.
    // Some pages (e.g. MobilePay return) already hold `state: internalState`.
    Object.keys(internalState).forEach((k) => {
      delete internalState[k]
    })
    Object.assign(internalState, nextState)
  }

  return {
    setCheckoutState,
    state: internalState,
    checkoutType
  }
}
